import type { ComponentType, ReactNode } from 'react';
import type { LucideProps } from 'lucide-react';

type Props = {
  icon: ComponentType<LucideProps>;
  title: string;
  description?: string;
  action?: ReactNode;
};

export function EmptyState({ icon: Icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-[var(--color-border)] bg-[var(--color-surface)] px-6 py-14 text-center">
      <div className="inline-flex size-11 items-center justify-center rounded-full bg-[var(--color-surface-muted)] text-[var(--color-foreground-muted)]">
        <Icon className="size-5" />
      </div>
      <div className="max-w-md space-y-1">
        <p className="text-sm font-medium">{title}</p>
        {description ? (
          <p className="text-sm text-[var(--color-foreground-muted)]">{description}</p>
        ) : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
